var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.83,
    height: 21.83,
    viewBox: "0 0 21.83 21.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon5",
    transform: "translate(-1180 -871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171948",
    "data-name": "\\uADF8\\uB8F9 171948",
    transform: "translate(1180 871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171947",
    "data-name": "\\uADF8\\uB8F9 171947",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-2",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(6.284)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-3",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(12.569)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-4",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(18.853)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-5",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(0 6.284)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-6",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(6.284 6.284)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-7",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(12.569 6.284)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-8",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(18.853 6.284)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-9",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(0 12.569)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-10",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(6.284 12.569)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-11",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(12.569 12.569)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-12",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(18.853 12.569)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-13",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(0 18.853)",
    fill: "#07457c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-14",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(6.284 18.853)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-15",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(12.569 18.853)",
    fill: "#fabe04"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16887-16",
    "data-name": "\\uD0C0\\uC6D0 16887",
    cx: 1.488,
    cy: 1.488,
    r: 1.488,
    transform: "translate(18.853 18.853)",
    fill: "#fabe04"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCircle);
export default __webpack_public_path__ + "static/media/squareCircle.6bdd193c45f491bade1fc56e7f1d7796.svg";
export { ForwardRef as ReactComponent };